module.exports = __webpack_public_path__ + "static/media/jw_banner.01248404.png";